import { render, staticRenderFns } from "./ContestCard.vue?vue&type=template&id=1b40cb7a&scoped=true"
import script from "./ContestCard.vue?vue&type=script&lang=ts"
export * from "./ContestCard.vue?vue&type=script&lang=ts"
import style0 from "./ContestCard.vue?vue&type=style&index=0&id=1b40cb7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b40cb7a",
  null
  
)

export default component.exports